const addCssUnit = val => {
  if (!val) {
    return '0px';
  }
  return typeof val === 'number' || !Number.isNaN(Number(val)) ? `${val}px` : val;
};
export default addCssUnit;
//# sourceMappingURL=add-css-unit.js.map